import React from 'react';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
import Login from './Login';
import Portal from './Portal';
import Settings from './Settings';
import Status from './Status';
import {ProtectedRoute} from '../ProtectedRoute'
import License from './License';
import BuyLicense from './BuyLicense';
import FinishRegistration from './Register/FinishRegistration';
import Schedule from './Schedule';
import ActiveAccount from './ActiveAccount';
import RecoverPassword from './RecoverPassword';
import PasswordUpdated from './ActiveAccount/PasswordUpdated';
import PasswordTokenExpired  from './ActiveAccount/PasswordTokenExpired';
import UserProfile from './UserProfile';
import {startTracing } from '../Helpers/GoogleAnalytics';
import {RouteWithCaptcha} from "../RouteWithCaptcha";
import TokenAuthenticate from './TokenAuthenticate';

startTracing();

const GestionXml = () => (
	<BrowserRouter>
		<Switch>
			<RouteWithCaptcha exact path='/' component={Login} />
			<ProtectedRoute exact path='/portal' component={Portal} />
			<ProtectedRoute exact path='/status' component={Status} />
			<ProtectedRoute exact path='/schedule' component={Schedule} />
			<ProtectedRoute exact path='/settings' component={Settings} />
			<ProtectedRoute exact path='/license' component={License} />
			<ProtectedRoute exact path='/userProfile' component={UserProfile} />
			<Route exact path='/buy-license/:type/:email' component={BuyLicense} />			
			<Route exact path={['/active-Account','/change-password']} component={ActiveAccount} />
			<Route exact path='/finish-registration' component={FinishRegistration} />
			<RouteWithCaptcha exact path='/recover-password' component={RecoverPassword} />
			<Route exact path='/updated-password' component={PasswordUpdated} />
			<Route exact path='/updated-password-expired' component={PasswordTokenExpired} />
			<Route exact path='/authenticate/:token' component={TokenAuthenticate} />
			<Redirect from='*' to="/" />
		</Switch>
	</BrowserRouter>
);

export default GestionXml;
